import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey:            'AIzaSyC6nVTXIRrm2Ejfvq3FankESg0fEq8WA3s',
  authDomain:        'migravip-e1afb.firebaseapp.com',
  projectId:         'migravip-e1afb',
  storageBucket:     'migravip-e1afb.appspot.com',
  messagingSenderId: '1234567890',
  appId:             '1:migravip:web:falei'
};

const app  = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db   = getFirestore(app);